import { getDataLayer } from './get-data-layer'
import { parseDecode } from './helpers'

// these two data attributes are set with our create-analytics-attributes
const layer = 'layer'
const layerMeta = 'layerMeta'

/** only allowed use case for importing: add handler on modal which doesnt populate to our body! */
// reason: type is related to element clicked on, which at this point we do not know
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const handleClick = (event: any) => {
  if (event && event.target) {
    let { target } = event
    let buttonOrAnchor

    while (target && target.tagName !== 'BODY') {
      if (target.tagName === 'BUTTON' || target.tagName === 'A') {
        buttonOrAnchor = target
        break
      }
      target = target.parentNode
    }

    let eventName
    let meta = {}

    // traverse parents to find our layer attribute
    while (buttonOrAnchor && buttonOrAnchor.tagName !== 'BODY') {
      if (buttonOrAnchor.dataset) {
        try {
          if (!eventName && Object.hasOwn(buttonOrAnchor.dataset, layer)) {
            eventName = buttonOrAnchor.dataset[layer]
          }

          if (Object.hasOwn(buttonOrAnchor.dataset, layerMeta)) {
            meta = {
              ...parseDecode(buttonOrAnchor.dataset[layerMeta]),
              // first comes, first serves, so we do not allow higher component to OVERRIDE a field already set!
              ...meta,
            }
          }
        } catch {
          //
        }
      }
      buttonOrAnchor = buttonOrAnchor.parentNode
    }

    // when we found an event name we have travered up till the body to aggregate meta data needed for the click
    // event. Stuff like a position, or inside which component etc etc.
    if (eventName) {
      getDataLayer()?.publish(eventName, meta)
    }
  }
}

export function delegateClickEvents() {
  if (typeof window === 'undefined') {
    return
  }

  // our scripts are injected in the Head section
  const html = document.querySelector('html')

  if (html) {
    html.addEventListener('click', handleClick)
  }
}
